<template>
  <div>
    <v-btn
      v-if="!webinarDetails.is_free"
      @click="register(webinarDetails)"
      height="42px"
      :block="$vuetify.breakpoint.xsOnly"
      width="200px"
      color="primary"
      class="register"
      :disabled="webinarDetails.is_registered"
    >
      <span v-if="!webinarDetails.is_registered"
        >Register for ₹{{ webinarDetails.price }}
      </span>
      <span v-else>Registered</span>
    </v-btn>
    <v-btn
      v-else
      @click="register(webinarDetails)"
      height="42px"
      :block="$vuetify.breakpoint.xsOnly"
      width="200px"
      color="primary"
      class="register"
      :disabled="webinarDetails.is_registered"
    >
      <span v-if="!webinarDetails.is_registered">Register for FREE </span>
      <span v-else>Registered</span>
    </v-btn>
    <WebinarPaymentDetails :openPaymentDetails="openPaymentDetails" />
    <freeWebinarRegister :freeRegisterSuccess="freeRegisterSuccess" />
    <freeRegisterDialog />
  </div>
</template>

<script>
import WebinarPaymentDetails from "./WebinarPaymentDetails.vue";
import freeWebinarRegister from "./freeWebinarRegisterDialog.vue";
import freeRegisterDialog from "./freeRegisterDialog.vue";
import Axios from "@/api/BaseAxios";
import { mapActions } from "vuex";
import { isAuthenticated } from "@/common/commonFunctions";
import apiUrl from "@/common/apiUrl";
import newAxios from "@/api/newAxios";

export default {
  props: {
    webinarDetails: {
      type: Object,
      required: true,
    },
    closedWebinarDialog: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openPaymentDetails: {
        flag: false,
        price: this.webinarDetails.price,
      },
      freeRegisterSuccess: {
        flag: false,
      },
      loading: false,
      payBtnLoader: false,
      order_detail: {},
      key_id: null,
      prefill: {},
      admin_id: null,
      order_id: null,
    };
  },
  components: {
    WebinarPaymentDetails,
    freeRegisterDialog,
    freeWebinarRegister,
  },

  methods: {
    ...mapActions({
      snackBar: "snackBar/showSnack",
    }),
    register(webinarDetails) {
      if (webinarDetails.is_free) {
        if (isAuthenticated()) {
          console.log("user authenticated true");
          this.freeWebinarRegister();
        } else {
          this.$store.commit("webinar/showRegisterModal", {
            show: true,
            id: webinarDetails.id,
            by: webinarDetails.owner.name,
            level: webinarDetails.level,
          });
        }
      } else {
        this.create_payment_order();
      }
    },
    freeWebinarRegister() {
      const onSuccess = () => {
        this.freeRegisterSuccess.flag = true;
        this.eventBus.$emit("reload-webinar");
      };
      const onFailure = () => {};
      let data = new FormData();
      data.append("name", this.webinarDetails.name);
      data.append("webinar", this.webinarDetails.id);
      data.append("email", this.webinarDetails.email);
      data.append("phone", this.webinarDetails.phone);
      newAxios("post", apiUrl.FREE_WEBINAR_REGISTER, {
        data,
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
    create_payment_order() {
      if (isAuthenticated()) {
        this.loading = true;
        const successHandler = (res) => {
          console.log(res);
          //
          // this.duration = res.data.duration_detail;
          this.order_detail = res.data.order_detail;
          this.order_id = res.data.order_detail.order_id;
          // this.admin_id = this.order_detail.group_detail.admin.id;
          // this.key_id = res.data.key_id;
          // this.prefill = res.data.prefill;
          //
          this.openPaymentGateway();

          // loader
          this.loading = true;
        };
        const failureHandler = () => {
          this.loading = false;
        };
        let formData = {};
        formData["webinar"] = this.webinarDetails.id;

        Axios.request_POST_PARAMS(
          "trending/create-webinar-payment/",
          formData,
          {},
          {},
          successHandler,
          failureHandler,
          false,
          true
        );
      } else {
        this.loading = true;
        const successHandler = (res) => {
          console.log(res);
          //
          // this.duration = res.data.duration_detail;
          this.order_detail = res.data.order_detail;
          this.order_id = res.data.order_detail.order_id;
          // this.admin_id = this.order_detail.group_detail.admin.id;
          // this.key_id = res.data.key_id;
          // this.prefill = res.data.prefill;
          //
          this.openPaymentGateway();
          this.$router.push("/login");
          // loader
          this.loading = true;
        };
        const failureHandler = () => {
          this.loading = false;
        };
        let formData = {};
        formData["webinar"] = this.webinarDetails.id;

        Axios.request_POST_PARAMS(
          "trending/create-webinar-payment/",
          formData,
          {},
          {},
          successHandler,
          failureHandler,
          false
        );
      }
    },

    openPaymentGateway() {
      const self = this;
      this.payBtnLoader = true;
      let total_price = this.order_detail.amount * 100;
      let options = {
        key: this.key_id, // Enter the Key ID generated from the Dashboard
        amount: total_price, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
        currency: "INR",
        // name: this.order_detail.group_detail.name,
        // description: "Paid Membership",
        // image: this.order_detail.group_detail.picture,
        order_id: this.order_detail.order_id,
        handler: function (response) {
          self.updatePaymentDetail(true, response);
          self.paymentSuccess = true;

          // alert(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature);
        },
        // callback_url: "http://localhost:8000/api/payment-webhook/",
        // prefill: {
        //   name: "Gaurav Kumar",
        //   email: "gaurav.kumar@example.com",
        //   contact: "9999999999",
        // },
        // prefill: this.prefill,
        // notes: {
        //   address: "Razorpay Corporate Office",
        // },
        theme: {
          color: "#3399cc",
        },
      };
      var rzp1 = window.Razorpay(options);
      rzp1.on("payment.failed", function (response) {
        this.payBtnLoader = false;
        this.loading = false;

        rzp1.close();
        self.snackBar({
          text: `failed : ${response.error.reason}, Payment ID: ${response.error.metadata.payment_id}`,
          color: "error",
          timeout: 2500,
        });
        self.updatePaymentDetail(false, response);
        self.notify();
      });
      rzp1.open();
    },
    updatePaymentDetail(success, res) {
      const successHandler = (res) => {
        this.eventBus.$emit("reload-webinar");
        this.payBtnLoader = false;
        this.loading = false;
        console.log(res);
        this.$logEvent("register_for_webinar");
        if (res.data.payment_data.status == "successful") {
          this.openPaymentDetails.flag = true;
          this.openPaymentDetails.item = res;
          this.closedWebinarDialog.flag = false;
        }
      };
      const failureHandler = () => {
        this.payBtnLoader = false;
        this.loading = false;
      };
      const finallyHandler = () => {
        if (success) {
          // this.eventBus.$emit("refresh-group-detail");
        }
      };
      let formData = {};
      formData["id"] = this.order_detail.id;
      formData["order_id"] = this.order_detail.order_id;
      if (success) {
        formData["payment_id"] = res.razorpay_payment_id;
        formData["payment_signature"] = res.razorpay_signature;
        formData["payment_status"] = "successful";
        // const url = `${location.protocol}//${location.host}/groups/2145`;
        // window.open(url, "_self");
      } else {
        this.payBtnLoader = false;
        formData["payment_status"] = "failed";
      }
      Axios.request_PATCH(
        "trending/update-webinar-payment/",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true,
        finallyHandler
      );
    },
    notify() {
      const successHandler = () => {};
      const failureHandler = () => {};
      let formData = {};
      formData["user_id"] = localStorage.getItem("user_id");
      formData["service"] = "webinar";
      formData["status"] = "success";
      formData["amount"] = this.order_detail.amount * 100;
      Axios.request_POST(
        "api/notify-covesto-payments",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.register {
  width: 200px;
  height: 45px;
  gap: 10px;
  border-radius: 6px;
  border: 1px 0px 0px 0px;
  //   Register text
  text-transform: initial;
  font-family: Avenir;
  font-size: 16px;
  font-weight: 500;
  line-height: 21.86px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 15px;
}
</style>
